import React from "react";
import { Button } from "react-bootstrap";
import { Navigate } from "react-router-dom";
import { store } from "../reducer/Store";
import ApiService from "../services/ApiService";
import PowerSettingsNewOutlinedIcon from "@mui/icons-material/PowerSettingsNewOutlined";
const Logout = () => {
  const { dispatch, state } = React.useContext(store);

  const logOut = () => {
    ApiService.request({}, "logout", "post")
      .then(function () {
        localStorage.clear();
        dispatch({ type: "SET_LOGOUT", payload: false });
      })
      .catch(function (error) {
        // manque un message quand c'est une error
        console.log(error.response.data.message);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  return (
    <>
      {!state.isAuth ? (
        <Navigate to="/login" />
      ) : (
        <div
          className="d-flex align-items-center"
          onClick={() => {
            logOut();
          }}
        >
          <PowerSettingsNewOutlinedIcon className="red" />
          &emsp;Déconnexion
        </div>
      )}
    </>
  );
};
export default Logout;
